<template>
  <div class="mb-6">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-2/12">
        <h1>Dashboard</h1>
      </div>
      <div class="vx-col w-full lg:w-7/12">
        <button
          class="bi-filter-button"
          :class="{ active: timeframe == 'day' }"
          @click="timeframe = 'day'"
        >
          24 h
        </button>
        <button
          class="bi-filter-button"
          :class="{ active: timeframe == 'week' }"
          @click="timeframe = 'week'"
        >
          7 Tage
        </button>
        <button
          class="bi-filter-button"
          :class="{ active: timeframe == 'month' }"
          @click="timeframe = 'month'"
        >
          30 Tage
        </button>
        <button
          class="bi-filter-button"
          :class="{ active: timeframe == 'all' }"
          @click="timeframe = 'all'"
        >
          Gesamt
        </button>
        <button
          class="bi-filter-button"
          :class="{ active: timeframe == 'custom' }"
          @click="timeframe = 'custom'"
        >
          Individuell
        </button>
      </div>
      <div class="vx-col w-full lg:w-3/12">
        <div class="daterange-toggler">
          <label>Zeitraum vergleichen</label>
          <data-input
            v-model="internalValue.doComparision"
            name="doComparision"
            type="bool"
          />
        </div>
      </div>
    </div>
    <div class="compare-bar">
      <div class="vx-row">
        <div class="vx-col w-full lg:w-2/12">
          <h3>Zeiträume wählen</h3>
        </div>
        <div class="vx-col w-full lg:w-10/12">
          <div class="vx-row">
            <div class="vx-col w-full lg:w-2/12"><p>Zeitraum 1</p></div>
            <div class="vx-col w-full lg:w-4/12">
              <DataInput
                class="px-2 inline-block"
                type="date"
                name="daterange"
                :value="defaultDate"
                :config="{
                  altFormat: 'd.m.Y H:i',
                  dateFormat: 'Y-m-d H:i',
                  mode: 'range'
                }"
                @input="updateDates"
              />
            </div>
            <template v-if="internalValue.doComparision">
              <div class="vx-col w-full lg:w-2/12"><p>Zeitraum 2</p></div>
              <div class="vx-col w-full lg:w-4/12">
                <DataInput
                  class="px-2 inline-block"
                  type="date"
                  name="daterange"
                  :value="defaultCompare"
                  :config="{
                    altFormat: 'd.m.Y H:i',
                    dateFormat: 'Y-m-d H:i',
                    mode: 'range'
                  }"
                  @input="updateCompares"
                />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput
  },
  data() {
    return {
      internalValue: {
        timeframe: {
          from: moment()
            .subtract(2, "days")
            .startOf("day"),
          to: moment()
            .subtract(1, "days")
            .startOf("day")
        },
        doComparision: true,
        compareTo: {
          from: moment()
            .subtract(3, "days")
            .startOf("day"),
          to: moment()
            .subtract(2, "days")
            .startOf("day")
        }
      },
      timeframe: "day",
      dateInputConfig: {
        altFormat: "d.m.Y H:i",
        dateFormat: "Y-m-d H:i",
        enableTime: true,
        time_24hr: true
      }
    };
  },
  computed: {
    defaultDate() {
      if (
        this.internalValue.timeframe.from &&
        this.internalValue.timeframe.to
      ) {
        return (
          moment(this.internalValue.timeframe.from).toISOString() +
          " bis " +
          moment(this.internalValue.timeframe.to).toISOString()
        );
      }
      return null;
    },
    defaultCompare() {
      if (
        this.internalValue.compareTo.from &&
        this.internalValue.compareTo.to
      ) {
        return (
          moment(this.internalValue.compareTo.from).toISOString() +
          " bis " +
          moment(this.internalValue.compareTo.to).toISOString()
        );
      }
      return null;
    }
  },
  watch: {
    timeframe(value) {
      switch (value) {
        case "day":
          this.internalValue.doComparision = true;
          this.internalValue.timeframe.from = moment()
            .subtract(1, "days")
            .startOf("day");
          this.internalValue.timeframe.to = moment().startOf("day");
          break;
        case "week":
          this.internalValue.doComparision = true;
          this.internalValue.timeframe.from = moment()
            .subtract(7, "days")
            .startOf("day");
          this.internalValue.timeframe.to = moment().startOf("day");
          this.internalValue.compareTo.from = moment()
            .subtract(14, "days")
            .startOf("day");
          this.internalValue.compareTo.to = moment()
            .subtract(7, "days")
            .startOf("day");
          break;
        case "month":
          this.internalValue.doComparision = true;
          this.internalValue.timeframe.from = moment()
            .subtract(30, "days")
            .startOf("day");
          this.internalValue.timeframe.to = moment().startOf("day");
          this.internalValue.compareTo.from = moment()
            .subtract(60, "days")
            .startOf("day");
          this.internalValue.compareTo.to = moment()
            .subtract(30, "days")
            .startOf("day");
          break;
        case "all":
          this.internalValue.timeframe.from = null;
          this.internalValue.timeframe.from = null;
          this.internalValue.doComparision = false;
          break;
        case "custom":
          this.internalValue.doComparision = true;
          this.internalValue.timeframe.from = moment()
            .subtract(60, "days")
            .startOf("day");
          this.internalValue.timeframe.to = moment()
            .subtract(30, "days")
            .startOf("day");
          this.internalValue.compareTo.from = moment()
            .subtract(90, "days")
            .startOf("day");
          this.internalValue.compareTo.to = moment()
            .subtract(60, "days")
            .startOf("day");
          break;
        default:
          break;
      }
    },
    internalValue: {
      deep: true,
      immidiate: true,
      handler(initialValue) {
        let value = JSON.parse(JSON.stringify(initialValue));
        if (value.timeframe.to) {
          value.timeframe.to = moment(value.timeframe.to);
        }
        if (value.timeframe.from) {
          value.timeframe.from = moment(value.timeframe.from);
        }
        if (value.compareTo.to) {
          value.compareTo.to = moment(value.compareTo.to);
        }
        if (value.compareTo.from) {
          value.compareTo.from = moment(value.compareTo.from);
        }
        this.$emit("input", value);
      }
    },
    "internalValue.doComparision"(value) {
      if (value) {
        this.internalValue.compareTo.from = moment(
          this.internalValue.timeframe.to
        ).clone();
        this.internalValue.compareTo.to = moment(
          this.internalValue.compareTo.from
        )
          .clone()
          .add(
            moment.duration(
              moment(this.internalValue.timeframe.to).diff(
                this.internalValue.timeframe.from
              )
            )
          );
      } else {
        this.internalValue.compareTo.to = null;
        this.internalValue.compareTo.from = null;
      }
    }
  },
  mounted() {
    this.$emit("input", this.internalValue);
  },
  methods: {
    updateDates(value) {
      if (value.includes(" bis ")) {
        const [from, to] = value.split(" bis ");
        this.internalValue.timeframe = {
          from: moment(from),
          to: moment(to)
        };
      }
    },
    updateCompares(value) {
      if (value.includes(" bis ")) {
        const [from, to] = value.split(" bis ");
        this.internalValue.compareTo = {
          from: moment(from),
          to: moment(to)
        };
      }
    }
  },
  emits: ["input"]
};
</script>
